import React, {useState} from 'react';
import clsx from 'clsx';
import { fade, makeStyles, useTheme } from '@material-ui/core/styles';
import {Avatar, Badge, Drawer, Menu, MenuItem, Tooltip, Box} from '@material-ui/core/';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/Button';
import MailIcon from '@material-ui/icons/Mail';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ViewDayIcon from '@material-ui/icons/ViewDay';
import PeopleIcon from '@material-ui/icons/People';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CategoryIcon from '@material-ui/icons/Category';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import { Link, useLocation, useHistory } from "react-router-dom";
import { LabelImportant } from '@material-ui/icons';
import Checkbox from '@material-ui/core/Checkbox';
import PublishIcon from '@material-ui/icons/Publish';
import * as RFIcon from 'react-feather'; 
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog';
import authentication from '../../services/authentication';
import language from '../../languages';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    backgroundColor: '#fafafa',
    color: '#000000',
    borderWidth: 0,
    boxShadow: 'none',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  title: {
    flexGrow: 1
  },
  // logout: {
  //   color: 'white'
  // },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    backgroundColor: '#2735A4',
    borderWidth: 0,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  selectedItem: {
    backgroundColor: '#F3F6FF !important',
    '& .MuiListItemIcon-root' : {
      color: '#2735A4'
    }
  },
  itemList: {
    '& .MuiListItemIcon-root' : {
      color: '#ffffff'
    }
  },
  sideTopIcons: {
    marginRight: theme.spacing(3)
  },
  profileMenu: {
      '& .MuiMenu-paper': {
          marginTop: theme.spacing(5.5),
          border: '1px solid #2735A4',
          borderRadius: 5
      },
      '& .MuiMenu-list': {
          margin: 0,
          padding: 0,
          '& :hover': {
              color: '#3076CA',
              backgroundColor: '#ffffff',
          }
      }
  },
  logoutTitle: {
    padding: '8px 16px',
    color: '#ffffff',
    backgroundColor: '#2735A4',
  },
  cancelButton: {
    color: '#2735A4',
    margin: '8px 8px;',
    textTransform: 'capitalize',
    borderColor: '#2735A4'
  },
  logoutButton: {
    color: '#ffffff',
    backgroundColor: '#3076CA',
    '&:hover': {
      backgroundColor: fade('#3076CA', 0.75),
    },
    margin: '8px 8px;',
    textTransform: 'capitalize'
  }
}));

export default function MiniDrawer(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [profileMenuAnchorEl, setProfileMenuAnchorEl] = React.useState(null);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  let history  = useHistory();
  let location = useLocation();
  const pathName = location.pathname;
  const { onToggle, isExpanded, isPinned,
    onPinned, user, userData, onAboutClick, appSettings,
    onSettingsClick,
    onSignOutClick,
    onSignUpClick,
    openSnackbar,
    onSignInClick, } = props;
  
  const lang = appSettings ? (appSettings.language ? appSettings.language: 'en') : 'en';

  const currentRole = userData ? (userData.roles ? userData.roles[0]: 'NA') : 'NA';

  const ADMIN_MENU = [
    {
      name: language[lang].Dashboard,
      to: '/dashboard',
      icon: <RFIcon.PieChart strokeWidth={2}/>
    },
    {
      name: "Restaurants",
      to: "/restaurants",
      icon: <RFIcon.Coffee strokeWidth={2} />
    },
    {
      name: 'Blogs',
      to: '/blogs',
      icon: <RFIcon.Clipboard strokeWidth={2} />
    },
    {
      name: language[lang].Settings,
      to: "/settings",
      icon: <RFIcon.Settings strokeWidth={2} />
    }
  ];

  const DEFAULT_MENU = [
  ];

  const handleProfileMenuClick = (event) => {
    setProfileMenuAnchorEl(event.currentTarget);
  };
  
  const handleProfileMenuClose = () => {
    setProfileMenuAnchorEl(null);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
    onToggle(true);
  };

  const handleDrawerClose = () => {
    if (!isPinned) {
      setOpen(false);
      onToggle(false);
    }
  };

  const userInRole = (roleName) => {
    const { userData } = props;
    return userData && userData.roles && userData.roles.includes(roleName);
  }

  const signOut = () => {
    authentication
      .signOut()
      .then(() => {
          // setLogoutDialogOpen(false)
          // setLoading(false)
          history.push('/')
          openSnackbar("Signed out", 'success');
      })
      .catch((reason) => {
        const code = reason.code;
        const message = reason.message;
        setLoading(false)

        switch (code) {
          default:
            openSnackbar(message, 'error');
            return;
        }
      })
      .finally(() => {
        
      });
  }

  const roleMap = ()=>{
    let map = [];
    if(userInRole('ADMIN'))
      map = ADMIN_MENU
    else 
     map = DEFAULT_MENU;
     return map;
  }

  return (
    <React.Fragment>
    {<ConfirmationDialog
      dialogProps={{
          open: logoutDialogOpen,
          onClose: () => { },
      }}
      content={
          <>
          <div className={classes.logoutTitle}><Typography variant="h6" >{language[lang].Logout}</Typography></div>
          <Box p={4} width='600px'>
              <Box p={2} >
              <Typography variant="subtitle2" >{language[lang].Logout_warning}</Typography>
              </Box>
          </Box>
          </>
      }
      dismissiveAction={<Button disabled={loading} variant="outlined" className={classes.cancelButton} onClick={() => { setLogoutDialogOpen(false) }}>{language[lang].Cancel}</Button>}
      confirmingAction={<Button disabled={loading} variant="contained" className={classes.logoutButton}  onClick={() => { signOut(); setLoading(true) }}>{language[lang].Logout}</Button>}
    />}
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        color="transparent" 
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          {/* <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <RFIcon.Menu />
          </IconButton> */}
          <Typography variant="h6" noWrap className={classes.title}>
            <img src={(appSettings && appSettings.brandLogo) ? appSettings.brandLogo : process.env.PUBLIC_URL + "avvAppLogo.png"} alt="Logo Text" style={{ height: '40px' }} />
            {(appSettings && appSettings.brandText) ? appSettings.brandText : 'Brand'}
          </Typography>
          {!user && (
            <ButtonGroup
              color="inherit"
              variant="outlined"
            >
              <Button onClick={onSignUpClick}>Sign up</Button>
              <Button onClick={onSignInClick}>Sign in</Button>
            </ButtonGroup>
          )}
          {
            user && (
              <>
              <RFIcon.HelpCircle strokeWidth={2} className={classes.sideTopIcons}  />
              <Badge badgeContent={5} color="error" className={classes.sideTopIcons} >
                <RFIcon.Bell strokeWidth={2} style={{marginRight: '5px'}} />
              </Badge>
              <Button aria-controls="simple-menu" className={classes.logout} aria-haspopup="true" onClick={handleProfileMenuClick}>
                {/* Welcome, {userData.firstName} [{currentRole}] */}
                <Avatar alt={userData.firstName} src={userData.profileImageUrl} />
                <ArrowDropDownIcon />
              </Button>
              <Menu
                id="simple-menu"
                anchorEl={profileMenuAnchorEl}
                keepMounted
                open={Boolean(profileMenuAnchorEl)}
                className={classes.profileMenu}
                onClose={handleProfileMenuClose}
              >
                <MenuItem onClick={()=>{handleProfileMenuClose(); history.push('/profile')}}>
                  <RFIcon.User color='#09205C' strokeWidth={2} style={{marginRight: '12px'}} /> {language[lang].My_Profile}
                </MenuItem>
                {/* <MenuItem onClick={handleProfileMenuClose}>Change Role</MenuItem> */}
                <MenuItem onClick={()=> {handleProfileMenuClose(); setLogoutDialogOpen(true)}}>
                  <RFIcon.LogOut color='#09205C' strokeWidth={2} style={{marginRight: '12px'}} /> {language[lang].Logout}
                </MenuItem>
              </Menu>
              </>
            )
          }
        </Toolbar>
      </AppBar>
      <Drawer
        // style={userInRole('MARKETER') ? {display: 'none'} : {}}
        // onMouseEnter={handleDrawerOpen}
        // onMouseLeave={handleDrawerClose}
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <Typography variant="h6" noWrap className={classes.title}>
            <img src={process.env.PUBLIC_URL + "only-log.png"} alt="LOGO" style={{ height: '40px' }} />
          </Typography>
          <Checkbox
            checked={isPinned}
            onChange={onPinned}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />{!isPinned &&
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          }
        </div>
        <Divider />
        {/* <List>
          {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
            <ListItem button key={text}>
              <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
        <Divider /> */}
        <List>
          {roleMap().map((menuItem, index) => (
            <ListItem className={(pathName == menuItem.to || pathName.includes(`${menuItem.to }/`)) ? classes.selectedItem : classes.itemList } button
              key={index}
              component={Link}
              to={menuItem.to}

              selected={pathName == menuItem.to}>
              <ListItemIcon>   
                <Tooltip title={menuItem.name} placement="right" arrow>
                  {menuItem.icon} 
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary={menuItem.name} />
            </ListItem>
          ))}
        </List>
      </Drawer>
      <main className={classes.content}>
      </main>
    </div>
    </React.Fragment>
  );
}